<div class="p-6 w-[min(92vw,520px)] space-y-4">
  <h3 class="text-lg font-semibold">
    {{ 'temporary_access_dialog.title' | translate }}
  </h3>

  @if (result(); as creds) {
    <div class="space-y-3">
      <p class="text-sm text-red-700 font-medium">
        {{ 'temporary_access_dialog.password_once_warning' | translate }}
      </p>
      <div class="rounded-md border p-3 space-y-2">
        <div class="flex items-end justify-between gap-3">
          <div class="min-w-0">
            <div class="text-xs text-gray-500">
              {{ 'temporary_access_dialog.email_label' | translate }}
            </div>
            <div class="font-mono text-sm break-all">{{ creds.email }}</div>
          </div>
          <x-text-copier
            [textToCopy]="creds.email"
            size="s"
            appearance="primary"
          />
        </div>
        <div class="flex items-end justify-between gap-3">
          <div class="min-w-0">
            <div class="text-xs text-gray-500">
              {{ 'temporary_access_dialog.password_label' | translate }}
            </div>
            <div class="font-mono text-sm break-all">{{ creds.password }}</div>
          </div>
          <x-text-copier
            [textToCopy]="creds.password"
            size="s"
            appearance="primary"
          />
        </div>
      </div>
      <div class="flex justify-end">
        <button tuiButton appearance="primary" (click)="done()">
          {{ 'temporary_access_dialog.done' | translate }}
        </button>
      </div>
    </div>
  } @else {
    <form class="space-y-4" [formGroup]="form" (ngSubmit)="submit()">
      <div>
        <label class="text-sm font-medium block mb-1" for="rolesProfileId">
          {{ 'temporary_access_dialog.roles_profile_label' | translate }}
        </label>
        <select
          id="rolesProfileId"
          formControlName="rolesProfileId"
          class="w-full border rounded px-3 py-2"
          [disabled]="loadingProfiles()"
        >
          <option [ngValue]="null">
            {{ 'temporary_access_dialog.profile_placeholder' | translate }}
          </option>
          @for (profile of rolesProfiles(); track profile.id) {
            <option [ngValue]="profile.id">
              {{
                profile.name ||
                  ('temporary_access_dialog.profile_fallback_prefix'
                    | translate) + profile.id
              }}
            </option>
          }
        </select>
      </div>

      <div>
        <label class="text-sm font-medium block mb-1" for="expiresAt">
          {{ 'temporary_access_dialog.expires_at_label' | translate }}
        </label>
        <input
          id="expiresAt"
          formControlName="expiresAt"
          type="date"
          class="w-full border rounded px-3 py-2"
        />
      </div>

      @if (errorMessage()) {
        <p class="text-sm text-red-600">{{ errorMessage() }}</p>
      }

      <div class="flex justify-end gap-2">
        <button
          type="button"
          tuiButton
          appearance="secondary"
          [disabled]="submitting()"
          (click)="close()"
        >
          {{ 'temporary_access_dialog.cancel' | translate }}
        </button>
        <button
          type="submit"
          tuiButton
          appearance="primary"
          [disabled]="submitting() || loadingProfiles()"
        >
          {{ 'temporary_access_dialog.submit' | translate }}
        </button>
      </div>
    </form>
  }
</div>
